/** Панель видимости слоёв: popover в toolbar и содержимое drawer. */
import { useProjectStore } from "@/shared/store";
import { LAYERS, countLayerItems, getPlanLayer } from "@/shared/plan";
import { useToggleVisibleLayer } from "@/shared/hooks";
import { UIKit } from "@/shared/ui";

const objects = (count: number) => {
	const mod10 = count % 10;
	const mod100 = count % 100;
	if (mod10 === 1 && mod100 !== 11) return `${count} объект`;
	if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${count} объекта`;
	return `${count} объектов`;
};

export const LayersPanelContent = () => {
	const layers = useProjectStore((s) => s.project.layers);
	const toggleVisibleLayer = useToggleVisibleLayer();
	return (
		<>
			<div className="mb-1 px-1.5 pt-0.5">
				<UIKit.Text className="text-sm font-bold text-ink">Слои</UIKit.Text>
			</div>
			<ul className="flex flex-col">
				{LAYERS.map((info) => {
					const layer = getPlanLayer(layers, info.kind);
					const count = countLayerItems(layers, info.kind);
					return (
						<li key={info.kind}>
							<button
								type="button"
								role="switch"
								aria-checked={layer.visible}
								className={`flex w-full items-center gap-2.5 rounded-md px-1.5 py-1.75 text-left hover:bg-slate-100${layer.visible ? " text-ink" : " text-ink"}`}
								onClick={() => toggleVisibleLayer(info.kind)}
							>
								<UIKit.Text
									as="span"
									className={`flex size-6 shrink-0 items-center justify-center rounded-md border${layer.visible ? " border-accent bg-accent-soft text-ink" : " border-border bg-slate-50 text-ink"}`}
									aria-hidden
								>
									{layer.visible ? <UIKit.IconEye /> : <UIKit.IconEyeOff />}
								</UIKit.Text>
								<UIKit.Text as="span" className="flex min-w-0 flex-1 flex-col">
									<UIKit.Text as="span" className="flex items-baseline gap-2 text-sm">
										<UIKit.Text as="span" className="font-bold text-ink">
											{info.label}
										</UIKit.Text>
										{!info.derived && count > 0 && (
											<UIKit.Text as="span" className="text-xs font-medium text-ink tabular-nums">
												{objects(count)}
											</UIKit.Text>
										)}
									</UIKit.Text>
									<UIKit.Text as="span" className="text-xs leading-snug text-muted">
										{info.description}
									</UIKit.Text>
								</UIKit.Text>
							</button>
						</li>
					);
				})}
			</ul>
		</>
	);
};
